import { Link } from "react-router-dom";

// Premium experience-first category identities
const CATEGORIES = [
  {
    displayName: "Adrenaline & Exploration",
    filterName: "Adrenaline & Exploration",
    tagline: "Beyond Every Limit",
    desc: "The rush that reminds you you're alive. Views only the fearless earn.",
    image: "https://images.pexels.com/photos/11114511/pexels-photo-11114511.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    height: "h-80"
  },
  {
    displayName: "Intimate Escapes",
    filterName: "Intimate Escapes",
    tagline: "For Two. Without Compromise.",
    desc: "Where the world quietly shrinks to just the two of you.",
    image: "https://images.pexels.com/photos/9470521/pexels-photo-9470521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    height: "h-80"
  },
  {
    displayName: "Elevated Indulgence",
    filterName: "Elevated Indulgence",
    tagline: "When Nothing Less Will Do",
    desc: "Every detail chosen because extraordinary is the baseline.",
    image: "https://images.unsplash.com/photo-1559329007-40df8a9345d8?w=800&q=80",
    span: "col-span-12 md:col-span-6 lg:col-span-4",
    height: "h-80"
  },
  {
    displayName: "Cultural Immersions",
    filterName: "Cultural Immersions",
    tagline: "Depth Beyond the Surface",
    desc: "Ancient rituals. Living traditions. The kind of depth that stays with you.",
    image: "https://images.unsplash.com/photo-1763479939733-eea29c578c17?w=800&q=80",
    span: "col-span-12 md:col-span-6 lg:col-span-6",
    height: "h-64"
  },
  {
    displayName: "Rhythm & Celebration",
    filterName: "Rhythm & Celebration",
    tagline: "Life at Full Volume",
    desc: "The kind of night that becomes a story you never stop telling.",
    image: "https://images.unsplash.com/photo-1768054183832-8b2307d994ab?w=800&q=80",
    span: "col-span-12 md:col-span-6 lg:col-span-3",
    height: "h-64"
  },
  {
    displayName: "Nature & Solitude",
    filterName: "Nature & Solitude",
    tagline: "Where Silence Finds You",
    desc: "The stillness that only arrives when civilization falls away.",
    image: "https://images.unsplash.com/photo-1770105328610-e138ba4597cc?w=800&q=80",
    span: "col-span-12 md:col-span-6 lg:col-span-3",
    height: "h-64"
  }
];

export default function ExperienceCategories() {
  return (
    <section data-testid="experience-categories-section" className="py-20 md:py-28 px-6 md:px-12 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        {/* Section header — centered to match rest of site */}
        <div className="text-center mb-12 md:mb-16">
          <p className="overline mb-4">Choose Your Experience</p>
          <h2 className="font-heading text-4xl md:text-5xl font-light text-[#FAFAFA] tracking-tight mb-3">
            Not Where. <span className="italic text-[#C9A84C]">How</span> You Travel.
          </h2>
          <p className="text-[#71717A] text-sm max-w-xl mx-auto leading-relaxed">
            Six dimensions of experience. Each one curated for a different way of feeling alive.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-5">
          {CATEGORIES.map((cat, i) => (
            <div
              key={cat.displayName}
              className={`${cat.span} ${cat.height} card-zoom relative overflow-hidden rounded-xl group cursor-pointer`}
              data-testid={`category-card-${cat.filterName.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <img
                src={cat.image}
                alt={cat.displayName}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent group-hover:from-black/80 transition-all duration-500" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="text-[10px] uppercase tracking-[0.22em] mb-1.5 text-[#C9A84C]">{cat.tagline}</p>
                <h3 className="font-heading text-xl md:text-2xl font-light text-white mb-1.5 leading-tight">
                  {cat.displayName}
                </h3>
                {/* Description — visible always on large cards, hover on small */}
                <p className={`text-xs text-[#A1A1AA] leading-relaxed transition-all duration-300 ${
                  i < 3 ? "opacity-100" : "opacity-0 group-hover:opacity-100"
                } max-w-xs`}>
                  {cat.desc}
                </p>
              </div>

              {/* Hover explore CTA */}
              <Link
                to={`/experiences?category=${encodeURIComponent(cat.filterName)}`}
                className="absolute inset-0 flex items-end justify-end p-5 md:p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#C9A84C] border border-[#C9A84C]/40 px-4 py-2 rounded-sm bg-black/30 hover:bg-[#C9A84C]/10 transition-colors">
                  Explore
                </span>
              </Link>
            </div>
          ))}
        </div>

        {/* Trust line */}
        <div className="mt-10 text-center">
          <p className="text-[#71717A] text-xs tracking-[0.2em] uppercase">
            Curated, not commoditized · Every experience is uniquely crafted · Designed around your personality
          </p>
        </div>
      </div>
    </section>
  );
}
